import React, { useEffect, useState } from "react";
import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";

function ImportantToKnow() {
  const { language,t } = useLanguage();

  const [contents, setContents] = useState({
    page9: {
      cont_title: "",
      cont_details: "",
    },
    page10: {
      cont_title: "",
      cont_details: "",
    },
    page11: {
      cont_title: "",
      cont_details: "",
    },
  });

  const [loading, setLoading] = useState(true);

  // =====================================================
  // LANGUAGE ID
  // =====================================================

  const getLanguageId = () => {
    if (
      typeof language === "number" ||
      !isNaN(Number(language))
    ) {
      return Number(language);
    }

    if (
      language &&
      typeof language === "object"
    ) {
      return (
        Number(
          language.lang_id ||
          language.language_id ||
          language.id
        ) || 1
      );
    }

    return 1;
  };

  const languageId = getLanguageId();

  // =====================================================
  // CLEAN HTML
  // =====================================================

  const cleanContentHtml = (html) => {
    if (!html) {
      return "";
    }

    return String(html)
      .replace(/<li>\s*<\/li>/gi, "")
      .replace(
        /<li>(?:\s|&nbsp;|<br\s*\/?>)*<\/li>/gi,
        ""
      )
      .replace(
        /<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi,
        ""
      )
      .replace(
        /<div>(?:\s|&nbsp;|<br\s*\/?>)*<\/div>/gi,
        ""
      );
  };

  // =====================================================
  // FETCH CONTENT PAGE
  // =====================================================

  const fetchContentPage = async (
    pageId,
    langId
  ) => {
    try {
      const response = await api.get(
        "/contents/content",
        {
          params: {
            page_id: pageId,
            lang_id: langId,
          },
        }
      );

      const result = response.data;

      if (
        result &&
        result.success &&
        result.data
      ) {
        if (Array.isArray(result.data)) {
          return result.data[0] || null;
        }

        return result.data;
      }

      return null;
    } catch (error) {
      console.error(
        `ERROR FETCHING PAGE ${pageId}:`,
        error
      );

      return null;
    }
  };

  // =====================================================
  // LOAD PAGES 9, 10, 11
  // =====================================================

  useEffect(() => {
    let cancelled = false;

    const loadContents = async () => {
      setLoading(true);

      const [
        page9,
        page10,
        page11,
      ] = await Promise.all([
        fetchContentPage(9, languageId),
        fetchContentPage(10, languageId),
        fetchContentPage(11, languageId),
      ]);

      if (cancelled) {
        return;
      }

      setContents({
        page9: {
          cont_title:
            page9?.cont_title || "",
          cont_details:
            page9?.cont_details || "",
        },

        page10: {
          cont_title:
            page10?.cont_title || "",
          cont_details:
            page10?.cont_details || "",
        },

        page11: {
          cont_title:
            page11?.cont_title || "",
          cont_details:
            page11?.cont_details || "",
        },
      });

      setLoading(false);
    };

    loadContents();

    return () => {
      cancelled = true;
    };
  }, [languageId]);

  // =====================================================
  // UI
  // =====================================================

  return (
    <div className="ft-bg">

      <section className="why-choose-us-area">

        <div className="container">

          {/* TITLE */}

          <div className="row">

            <div
              className="col-md-12"
              align="center"
            >

              <div
                className="
                  heading-section
                  heading-section-white
                "
              >
{/* 
                <p
                  style={{
                    textAlign: "center",
                    position: "relative",
                    top: "26px",
                    fontSize: "20px",
                  }}
                >
                  Also
                </p> */}

                <h2
                  className="aboutp"
                  style={{
                    textAlign: "center",
                  }}
                >
                   {t("othersnewstatics.othersnewstatic70",
                    "Important to know")}
                </h2>

              </div>

            </div>

          </div>

          {/* CONTENT */}

          <div className="row">

            {/* PAGE 9 */}

            <div
              className="col-md-6"
              style={{
                padding: "0 10px",
                marginBottom: "20px",
              }}
            >

              <div
                className="
                  services
                  services-2
                  w-100
                "
                style={{
                  height: "100%",
                }}
              >

                <div
                  className="
                    pr28
                    text-1
                    text
                    w-100
                  "
                  style={{
                    height: "100%",
                  }}
                >

                  <div
                    className="price-card"
                    style={{
                      height: "100%",
                    }}
                  >

                    <div className="content">

                      <h2>
                        {loading
                          ? "Loading..."
                          : contents.page9
                              .cont_title ||
                            "Also important to know:"}
                      </h2>

                    </div>

                    {!loading &&
                      contents.page9
                        .cont_details && (

                        <div
                          className="why-content-page9"
                          dangerouslySetInnerHTML={{
                            __html:
                              cleanContentHtml(
                                contents.page9
                                  .cont_details
                              ),
                          }}
                        />

                      )}

                  </div>

                </div>

              </div>

            </div>

            {/* PAGE 10 + PAGE 11 */}

            <div
              className="col-md-6"
              style={{
                padding: "0 10px",
                marginBottom: "20px",
              }}
            >

              <div
                className="
                  pr28
                  services
                  services-2
                  w-100
                "
                style={{
                  height: "100%",
                }}
              >

                <div
                  className="price-card1"
                  style={{
                    height: "100%",
                  }}
                >

                  {/* PAGE 10 */}

                  <div className="content">

                    <h2>
                      {loading
                        ? "Loading..."
                        : contents.page10
                            .cont_title ||
                          "Attention!!"}
                    </h2>

                  </div>

                  {!loading &&
                    contents.page10
                      .cont_details && (

                      <div
                        className="why-content-page10"
                        dangerouslySetInnerHTML={{
                          __html:
                            cleanContentHtml(
                              contents.page10
                                .cont_details
                            ),
                        }}
                      />

                    )}

                  <div className="clearfix0"></div>

                  {/* PAGE 11 */}

                  <div className="content">

                    <h2>
                      {loading
                        ? "Loading..."
                        : contents.page11
                            .cont_title ||
                          "Enjoy your holidays"}
                    </h2>

                  </div>

                  {!loading &&
                    contents.page11
                      .cont_details && (

                      <div
                        className="why-content-page11"
                        dangerouslySetInnerHTML={{
                          __html:
                            cleanContentHtml(
                              contents.page11
                                .cont_details
                            ),
                        }}
                      />

                    )}

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
}

export default ImportantToKnow;